module.exports = __webpack_public_path__ + "img/156.932ca036.jpg";